import type { TableColumnConfig } from '../../../data/table-column-config';
import { DateTimeCellComponent } from './date-time-cell.component';

export function createDateTimeColumn<T>(
  fieldId: string,
  fieldName: keyof T,
  labelI18nKey: string,
  sortable = false,
): TableColumnConfig<T> {
  return {
    id: fieldId,
    field: fieldName,
    label: labelI18nKey,
    cellContent: DateTimeCellComponent,
    sortable,
  };
}
